import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const LANGS = ["en", "fr", "da", "de"] as const;

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = LANGS.includes(i18n.language as (typeof LANGS)[number])
    ? i18n.language
    : "en";

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300/70 bg-background-50 px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 cursor-pointer"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <i className="ri-global-line text-base text-primary-600" aria-hidden="true"></i>
        <span>{t(`common.lang.${current}`)}</span>
        <i
          className={`ri-arrow-down-s-line text-base transition-transform ${open ? "rotate-180" : ""}`}
          aria-hidden="true"
        ></i>
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-xl border border-background-200 bg-white py-1">
          {LANGS.map((code) => (
            <button
              key={code}
              type="button"
              onClick={() => {
                i18n.changeLanguage(code);
                setOpen(false);
              }}
              className={`flex w-full items-center justify-between px-4 py-2.5 text-left text-sm transition-colors cursor-pointer hover:bg-background-100 ${
                current === code
                  ? "font-semibold text-primary-700"
                  : "text-foreground-700"
              }`}
            >
              <span>{t(`common.lang.${code}`)}</span>
              {current === code && (
                <i className="ri-check-line text-primary-600" aria-hidden="true"></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}